import script from "./StrongPass.vue?vue&type=script&setup=true&lang=js"
export * from "./StrongPass.vue?vue&type=script&setup=true&lang=js"

import "./StrongPass.vue?vue&type=style&index=0&id=56e84130&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e84130"]])

export default __exports__